import { CicReasonStatusEnum } from 'constants/status';

export const MAX_LENGTH_REASON_NOTE = 500;
export const TEXTAREA_ROWS_REASON_NOTE = 4;

export const SHOW_DELETE_BUTTON_STATUSES = [CicReasonStatusEnum.PENDING, CicReasonStatusEnum.SAVED];
export const EDIT_ALLOWED_STATUSES = [CicReasonStatusEnum.PENDING, CicReasonStatusEnum.SAVED];
